export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fff11087d0261b918dee7f7c9d40a942b9820fea6&name=fetchTypeahead!'